define(function (require) {
    require("@modules/tools/ko.bootstrapSelect");
    var ko = require("knockout");
    var $ = require("jquery");
    require("@modules/tools/ko.bootstrap-select");
    var SNFSearchViewModel = require("@modules/tools/snf-search/snfSearchViewModel");
    require("@modules/tools/ko.dpOpenClose");

    var gtmDataLayerPush = function (parameters, defaultParameters) {
        var dataLayer = window.dataLayer || [];
        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        var jsonObject = {
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Snfs Search"
        };

        if (parameters.zipOrAddress && parameters.zipOrAddress !== defaultParameters["zipOrAddress"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-snfs",
                eventAction: "Address",
                eventLabel: parameters.zipOrAddress
            });
            jsonObject.snfAddress = parameters.zipOrAddress;
        }

        if (parameters.year && parameters.year !== defaultParameters["year"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-snfs",
                eventAction: "Year",
                eventLabel: parameters.year
            });
            jsonObject.snfYear = parameters.year;
        }

        if (parameters.radius && parameters.radius !== defaultParameters["radius"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-snfs",
                eventAction: "MilesFromAddress",
                eventLabel: parameters.radius + " Miles"
            });
            jsonObject.snfRadius = parameters.radius;
        }

        if (parameters.name && parameters.name !== defaultParameters["name"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-snfs",
                eventAction: "SnfNameId",
                eventLabel: parameters.name
            });
            jsonObject.snfNameId = parameters.name;
        }

        dataLayer.push(jsonObject);
    };

    if ($("#snf-search").length > 0) {
        ko.applyBindings(new SNFSearchViewModel(gtmDataLayerPush));
        $(".hide-load").removeClass("hide-load");
        $(".tool-load").removeClass("tool-load");
    }
});
